import { Component, Input } from '@angular/core';

@Component({
    selector: 'aa-column-header-item',
    template: '',
    standalone: false
})
export class ColumnHeaderItemComponent
{
    @Input() labelKey: string;
    @Input() sorterKey: string;
    @Input() class: string;
    @Input() active: boolean = false;
    @Input() sortable: boolean = true;
}
